import { Component, OnInit, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

declare var i18nVS: any;
declare var SendPlainFormEmailObjetosPerdidos: any;
declare var portletNameFormObjetosPerdidos;
declare var idCiudadLiferay: any; // El id de la ciudad en la que estamos
declare var jsonGetContentURL: any;
declare var privaciPolicyId: any;
declare var responsesMap;

declare function openModal(nameModal): any;
declare function closeModal(nameModal): any;

declare function getContentsFunction(): any;
declare function sendFormFunction(idForm, finalURL) :any;

@Component({
    selector: 'app-objetos-perdidos',
    templateUrl: './objetos-perdidos.component.html',
    styleUrls: ['./objetos-perdidos.component.css']
})

export class AppComponent implements OnInit {
    i18nL = i18nVS;
    actionForm = ''; // Action del formulario
    portletName = ''; // Nombre del portlet
    idCiudad = '3';
    modalVisible = false; // Si esta modal es visible o no
    showSpinner = '';

    CadaCuanto = 30; // En minutos
    MinutosTotales = 0;
    Horas = [ '00:00' ];
    Huecos = (24 * 60) / this.CadaCuanto;

    // Validaciones
    nombreClass = '';
    apellidosClass = '';  
    documentoNumeroClass = '';  
    telefonoClass = '';  
    emailClass = '';
    direccionClass = '';
    cpClass  = '';
    dateClass  = '';
    hourClass  = '';
    busNumberClass = '';
    lineaClass = '';
    descripcionClass = '';
    ciudadClass = '';
    aceptarAcuerdoClass = 'invisible';
    theHtmlString = '';

	responseFormSpinner = "invisible";
	successResponseForm = "invisible";
	errorResponseForm = "invisible";
	showResponse = false;
	responseText = "";
	responseMapKey = 0;
	
    /*----------------------------------------------- Funciones ----------------------------------------------------*/
    public leerDatos (): Observable<Response> {
        var body = this.portletName + 'contentPLID=' + privaciPolicyId;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }); // Set content type to JSON
        const options = new RequestOptions({ headers: headers }); // Create a request option
        return this.http.post(jsonGetContentURL, body, options);
    }

    public comprobandoJson (res) {
        this.showSpinner = 'invisible';
        this.theHtmlString = res._body;
    }

    public errorEnElJson() {
        console.log('Error en la carga del contenido');
    }
    
    public toggleModal() {
        if (!this.modalVisible) {
            this.modalVisible = true;
			if (this.theHtmlString == "") {
				this.showSpinner = '';
            	this.leerDatos().subscribe(res => this.comprobandoJson(res), (err) => this.errorEnElJson());
        	}
			openModal('contentModal_sagComponentName');
        } else {
            closeModal('contentModal_sagComponentName');
            this.modalVisible = false;
        }
    }
    
    public contarHoras() {
        var HoraFinal = '';
        for (var i = 0; i < this.Huecos; i++) {
            this.MinutosTotales += this.CadaCuanto;
        
            if (Math.trunc(this.MinutosTotales / 60) < 10) { // Rellena con un 0 extra en caso de ser necesario "00:30"
                HoraFinal = '0' + String(Math.trunc(this.MinutosTotales / 60)) + ':';
            } else {
                HoraFinal = String(Math.trunc(this.MinutosTotales / 60)) + ':';
            }

            if (this.MinutosTotales % 60 < 10) {  // Rellena con un 0 extra en caso de ser necesario "00:30"
                HoraFinal = HoraFinal + '0' + String(this.MinutosTotales % 60);
            } else {
                HoraFinal = HoraFinal + String(this.MinutosTotales % 60);
            }

            this.Horas.push(HoraFinal);
        }
    }

    public validarFormulario() {
        var validado = true;

        if ((<HTMLInputElement>document.getElementById('nombre')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('nombre')).placeholder = this.i18nL.form_campoObligatorio;
            this.nombreClass = 'inputError';
            validado = false;
        }
        
        if ((<HTMLInputElement>document.getElementById('apellidos')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('apellidos')).placeholder = this.i18nL.form_campoObligatorio;
            this.apellidosClass = 'inputError';
            validado = false;
        }
        
        if ((<HTMLInputElement>document.getElementById('documentoNumero')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('documentoNumero')).placeholder = this.i18nL.form_campoObligatorio;
            this.documentoNumeroClass = 'inputError';
            validado = false;
        }        
        
        if ((<HTMLInputElement>document.getElementById('telefono')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('telefono')).placeholder = this.i18nL.form_campoObligatorio;
            this.telefonoClass = 'inputError';
            validado = false;
        }
        
        if ((<HTMLInputElement>document.getElementById('email')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('email')).placeholder = this.i18nL.form_campoObligatorio;
            this.emailClass = 'inputError';
            validado = false;
        }
        
        if ((<HTMLInputElement>document.getElementById('direccion')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('direccion')).placeholder = this.i18nL.form_campoObligatorio;
            this.direccionClass = 'inputError';
            validado = false;
        }
        
        if ((<HTMLInputElement>document.getElementById('cp')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('cp')).placeholder = this.i18nL.form_campoObligatorio;
            this.cpClass = 'inputError';
            validado = false;
        }
        
        if ((<HTMLInputElement>document.getElementById('date')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('date')).placeholder = this.i18nL.form_campoObligatorio;
            this.dateClass = 'inputError';
            validado = false;
        }
        
        if ((<HTMLInputElement>document.getElementById('hour')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('hour')).placeholder = this.i18nL.form_campoObligatorio;
            this.hourClass = 'inputError';
            validado = false;
        }
        
        if ((<HTMLInputElement>document.getElementById('busNumber')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('busNumber')).placeholder = this.i18nL.form_campoObligatorio;
            this.busNumberClass = 'inputError';
            validado = false;
        }
        
        if ((<HTMLInputElement>document.getElementById('linea')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('linea')).placeholder = this.i18nL.form_campoObligatorio;
            this.lineaClass = 'inputError';
            validado = false;
        }
        
        if ((<HTMLInputElement>document.getElementById('descripcion')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('descripcion')).placeholder = this.i18nL.form_campoObligatorio;
            this.descripcionClass = 'inputError';
            validado = false;
        }
        
        if (!(<HTMLInputElement>document.getElementById('cndp')).checked) {
            this.aceptarAcuerdoClass = 'visibleError';
            validado = false;
        }
        if(validado){
        	this.showResponseForm();
        	this.responseMapKey = sendFormFunction('iniciarObjetosPerdidosForm', SendPlainFormEmailObjetosPerdidos);
        }
        return false;
    }

    public clearClass(inputId) {
        if (inputId == "cndp")  {
            if ((<HTMLInputElement>document.getElementById('cndp')).checked) {
                this.aceptarAcuerdoClass = 'invisible';
            } else {
                this.aceptarAcuerdoClass = 'visibleError';
            }
        } else {
            if ((<HTMLInputElement>document.getElementById(inputId)).value.trim() !== '') {
                this.nombreClass = '';
            }
        }
    }

    public aceptCNDP() {
        if ((<HTMLInputElement>document.getElementById('cndp')).checked) {
            (<HTMLInputElement>document.getElementById('cndp')).checked = false;
        } else {
            (<HTMLInputElement>document.getElementById('cndp')).checked = true;
            this.clearClass(7);
        }
    }

    public showResponseForm () {
		this.resetView ();
		this.showResponse = true;
		this.checkForResponseCorutine();
		this.responseFormSpinner = "";
		this.successResponseForm = "invisible";
		this.errorResponseForm = "invisible";
		this.responseText = "";
	}
	
	private checkForResponseCorutine () {​​​​​
		if (typeof responsesMap.get(this.responseMapKey) != 'undefined' && responsesMap.get(this.responseMapKey) != "" && this.showResponse) {​​​​​
			this.responseFormSpinner = "invisible";
			var actualResponse = JSON.parse(responsesMap.get(this.responseMapKey));
			if (actualResponse.success != null) {​​​​​
				this.successResponseForm = "";
				this.responseText = actualResponse.success;
			}​​​​​ else {​​​​​
				this.errorResponseForm = "";
				this.responseText = actualResponse.error;
			}​​​​​
			this.responseMapKey = -1;
		}​​​​​ else {​​​​​
			setTimeout(() => this.checkForResponseCorutine(), 250);
		}​​​​​
	}​​​​​
	
	public resetView () {
		this.responseFormSpinner = "invisible";
		this.successResponseForm = "invisible";
		this.errorResponseForm = "invisible";
		this.showResponse = false;
		this.responseText = "";
	}
    
    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {
        this.portletName = portletNameFormObjetosPerdidos;
        this.idCiudad = idCiudadLiferay;
        this.contarHoras();
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(private http: Http, private renderer: Renderer2) { }

}



// WEBPACK FOOTER //
// ./src/app/objetos-perdidos.component.ts